import { initialize, LDClient } from 'launchdarkly-js-client-sdk';
import computeHash from 'utils/computeHash';

let clientPromise: Promise<LDClient | null> | null = null;

const initLDClient = (): Promise<LDClient | null> => {
  if (clientPromise) {
    return clientPromise;
  }

  const ldConfig = window._config?.launchDarkly;
  if (!ldConfig?.defaultUserKey) {
    clientPromise = Promise.resolve(null);
    return clientPromise;
  }

  const client = initialize(
    ldConfig.clientSideID,
    { key: ldConfig.defaultUserKey },
    {
      hash: computeHash(ldConfig.defaultUserKey, ldConfig.sdkKey),
      bootstrap: 'localStorage',
      streaming: false,
      evaluationReasons: true,
    },
  );

  clientPromise = client
    .waitForInitialization()
    .then(() => client)
    .catch(() => client);

  return clientPromise;
};

export default initLDClient;
